'use client'

import { usePostHogPageView } from '../hooks/usePostHogPageView'

const PostHogPageViewTracker = () => {
  usePostHogPageView()
  return null
}

export default PostHogPageViewTracker
